import(/* webpackMode: "eager", webpackExports: ["ProblemDrawer"] */ "/app/src/app/(citizen)/votacao/@drawer/problemas/[id]/drawer/problem-drawer.tsx");
